// extracted by mini-css-extract-plugin
module.exports = {"card":"style_card__2S2cj","otherContent":"style_otherContent__1DQuy","chartCnt":"style_chartCnt__3-dvg"};